import * as yup from 'yup';

export const AuthSignInDataSchema = yup.object({
  username: yup.string().required(),
  password: yup.string().required(),
  remember: yup.bool().optional(),
});

export type AuthSignInData = yup.InferType<typeof AuthSignInDataSchema>;
